<template>
  <div class="zone" @click="hangleGoZone"></div>
</template>
<script>
import wx from 'weixin-js-sdk'

export default {
  data () {
    return {

    }
  },
  methods: {
    hangleGoZone () {
      wx.miniProgram.redirectTo({
        url: '/pagesZone/zone/zone'
      })
    }
  },
  created () {

  }
}
</script>

<style scoped lang="less">
.zone{
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 90px;
  background: url(@/assets/zone/zone.png) no-repeat center;
  background-size: 100% 100%;
}
</style>
